import { render, staticRenderFns } from "./Formulario.vue?vue&type=template&id=c2d7fd52"
import script from "./Formulario.vue?vue&type=script&lang=ts"
export * from "./Formulario.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports